const nodeListToArray = (nodeList) => [].slice.call(nodeList);

export default nodeListToArray;
